import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/App.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import router from "./routes/routes";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import getMPTheme from "./assets/theme/getMPTheme";
import CssBaseline from "@mui/material/CssBaseline";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store from "./store/store";
import { Provider } from "react-redux";
import { Snackbar } from "@mui/material";
import SnackbarComponent from "./components/SnackbarComponent";
// TODO - FIX GOOGLE CLIENT ID TO .env

const MPTheme = createTheme(getMPTheme("light"));
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={MPTheme}>
        <CssBaseline enableColorScheme />
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
          <SnackbarComponent />
          <RouterProvider router={router} />
        </GoogleOAuthProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
